import React from 'react';
import './TermsOfUse.css';

const TermsOfUse = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Termos de Uso</h1>
        <div className="terms-content">
          <p className="terms-intro">
            Estes Termos de Uso regulam a utilização do site institucional do escritório
            <strong> Navarro & Vieira Advogados</strong>.
            Ao navegar neste site, você declara ciência e concordância com as condições abaixo.
          </p>

          <section className="terms-section">
            <h2>1. Finalidade do site</h2>
            <p>
              O conteúdo publicado neste site possui caráter informativo e institucional, voltado à apresentação
              do escritório, suas áreas de atuação e canais de contato.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Informações e responsabilidade</h2>
            <p>
              As informações disponibilizadas não substituem consulta jurídica individualizada. Cada caso concreto
              deve ser analisado de forma específica por profissional habilitado.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Uso adequado</h2>
            <ul>
              <li>Não utilizar o site para fins ilícitos ou abusivos.</li>
              <li>Não tentar acessar áreas restritas sem autorização.</li>
              <li>Não praticar ações que comprometam a disponibilidade do serviço.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Propriedade intelectual</h2>
            <p>
              Textos, logotipos e demais materiais deste site são protegidos por direitos autorais e não podem
              ser reproduzidos sem autorização prévia.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Alterações</h2>
            <p>
              O escritório pode atualizar estes termos a qualquer momento. Recomendamos revisão periódica.
            </p>
          </section>

          <div className="terms-footer">
            <p><strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-BR')}</p>
            <p>
              Marcos Antônio dos Santos Navarro (OAB/PR 101.424) · Mateus Bortotto Vieira (OAB/PR 101.759)
            </p>
            <p>© {new Date().getFullYear()} Navarro & Vieira Advogados. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
